/* eslint-disable */
import { Typography } from '@material-ui/core';
import { graphql } from 'gatsby';
import * as React from 'react';
import slugify from '@sindresorhus/slugify';

import { Layout } from '../../../components/layout';
import { MoreButton } from '../../../components/more-button';
import ProductListing from '../../../components/product-listing';
import Seo from '../../../components/seo';
import WhiteSpace from '../../../components/styled/white-space';

export default function ProductTypeIndex({
  data: { products },
  pageContext: { productType },
}) {
  return (
    <Layout>
      <Seo title={`Category: ${productType}`} />
      <ProductListing title={productType} products={products.nodes} />
      {products.pageInfo.hasNextPage && (
        <MoreButton to={`/search?p=${slugify(productType)}#more`}>
          Más productos...
        </MoreButton>
      )}
    </Layout>
  );
}

export const query = graphql`
  query ($productType: String!) {
    products: allShopifyProduct(
      filter: { productType: { eq: $productType } }
      sort: { fields: publishedAt, order: ASC }
      limit: 24
    ) {
      nodes {
        ...ProductCard
      }
      pageInfo {
        hasNextPage
      }
    }
  }
`;
